import React from "react";
import PropTypes from "prop-types";

// core components
import CustomInput from "components/CustomInput/CustomInput.js";

export default function ViewCounter(props) {
  const { counter } = props;
  return (
    <>
      <CustomInput
        labelText="Code"
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          disabled: true,
          value: counter.code
        }}
      />
      <CustomInput
        labelText="Name"
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          disabled: true,
          value: counter.name
        }}
      />
    </>
  );
}

ViewCounter.propTypes = {
  counter: PropTypes.object
};
